import { IVehicleResume, VehiclePost, VehicleSearch } from '../interfaces/Vehicle';
import getUrlParameters from '../utils/getUrlParameters';
import { getUrlMvmApi } from '../utils/util';
import ApiHandler from './ApiHandler';

export const baseURL = String(getUrlMvmApi(window));

export default class VehicleApi {
    static async searchVehicle(params: VehicleSearch) {
        var response = await ApiHandler(baseURL).get('Vehicles/search',  { params: getUrlParameters(params) });
        return response.data;
    }

    static async getListVehicle(vehicleCode: number) {
        var response = await ApiHandler(baseURL).get(`Vehicle/${vehicleCode}`);
        return response.data;
    }

    static async getVehicle(vehicleCode: number) {
        var response = await ApiHandler(baseURL).get(`Vehicles/${vehicleCode}`);
        return response.data;
    }

    static async getVehicleByPlateNumber(vehiclePlateNumber: number) {
        var response = await ApiHandler(baseURL).get(`Vehicles/GetLicensePlate/${vehiclePlateNumber}`);
        return response.data;
    }

    static async postVehicle(vehicle: VehiclePost) {
        var response = await ApiHandler(baseURL).post('Vehicles', vehicle);
        return response.data;
    }

    static async cadVehicle(vehicle: IVehicleResume) {
        var response = await ApiHandler(baseURL).post('Vehicles', vehicle);
        return response.data;
    }

    static async putVehicle(vehicle: VehiclePost) {
        var response = await ApiHandler(baseURL).put('Vehicles', vehicle);
        return response.data;
    }

    static async deleteVehicle(vehicleId: number) {
        var response = await ApiHandler(baseURL).delete(`Vehicles/${vehicleId}`);
        return response.data;
    }

    static async deleteVehicleCache(plate?: string) {
        const url = plate ? `Vehicles/cache/${encodeURIComponent(plate)}` : 'Vehicles/cache';
        var response = await ApiHandler(baseURL).delete(url);
        return response.data;
    }
}
